// Helpers for the optional `order.guestName` object captured on AvantStay
// orders:
//   { reservationHolderFirstName, reservationHolderLastName,
//     orderPlacedByFirstName, orderPlacedByLastName }
// Every helper tolerates a missing object (legacy / non-AvantStay orders) and
// never returns "undefined" / "null" strings. Names are only joined here for
// presentation; the backend keeps them as separate fields.

const joinNameParts = (...parts) =>
  parts
    .map((part) => (typeof part === 'string' ? part.trim() : ''))
    .filter(Boolean)
    .join(' ')

export const getReservationHolderName = (order) =>
  joinNameParts(
    order?.guestName?.reservationHolderFirstName,
    order?.guestName?.reservationHolderLastName
  )

export const getOrderPlacedByName = (order) =>
  joinNameParts(
    order?.guestName?.orderPlacedByFirstName,
    order?.guestName?.orderPlacedByLastName
  )
// Best-effort display name for greeting copy ("Hi {name},"). Handles the
// legacy case where some payloads carried `guestName` as a plain string, the
// new nested object, and orders with neither.
export const getOrderGuestDisplayName = (order, fallback = '') => {
  const rawGuestName = order?.guestName
  if (typeof rawGuestName === 'string' && rawGuestName.trim()) {
    return rawGuestName.trim()
  }
  return (
    getOrderPlacedByName(order) ||
    getReservationHolderName(order) ||
    (typeof order?.guestFirstName === 'string' && order.guestFirstName.trim()) ||
    fallback
  )
}
